import React from "react";
import Button from "./Button";

const ConfirmBoxModal = ({ isOpen, onClose, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-window">
                <h3>Подтверждение</h3>
                <p>Подтвердите свои действия!</p>

                <div className="modal-actions">
                    <Button className="success" onClick={onConfirm}>
                        Принять
                    </Button>
                    <Button className="danger" onClick={onClose}>
                        Отмена
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmBoxModal;
